export const SUCCCESS_EMAIL = "E-mail succesvol verzonden";
